import FdPersonalInfoBrandingPage from "@faire/prototype-playground/workspace/mle/fd-personal-info-branding";
import FirstSteps3BrandCartPage from "@faire/prototype-playground/workspace/mle/first-steps-3-brand-cart";
import NetTermsTransitionRevealPage from "@faire/prototype-playground/workspace/mle/net-terms-transition-reveal";
import PersonalInfoLockedAfterAccountCreationPage from "@faire/prototype-playground/workspace/mle/personal-info-locked";
import SignupGranularStepAnimationsPage from "@faire/prototype-playground/workspace/mle/signup-granular-step-animations";
import SignupWelcomePage from "@faire/prototype-playground/workspace/mle/signup-welcome";
import { Route, Switch } from "react-router-dom";

export function MatthewLeandresRoutes() {
  return (
    <Switch>
      <Route path="/mle/fd-personal-info-branding" component={FdPersonalInfoBrandingPage} />
      <Route
        path="/mle/first-steps-3-brand-cart"
        component={FirstSteps3BrandCartPage}
      />
      <Route
        path="/mle/net-terms-transition-reveal"
        component={NetTermsTransitionRevealPage}
      />
      <Route
        path="/mle/personal-info-locked"
        component={PersonalInfoLockedAfterAccountCreationPage}
      />
      <Route
        path="/mle/signup-granular-step-animations"
        component={SignupGranularStepAnimationsPage}
      />
      <Route path="/mle/signup-welcome" component={SignupWelcomePage} />
    </Switch>
  );
}

export const slug = "mle";
